import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/userservice/api/role/list',
    method: 'post',
    data: data
  });
}
export function fetchPlotRoleList(data) {
  return request({
    url: '/userservice/api/role/plotRoleList',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/userservice/api/role/detail',
    method: 'post',
    data: data
  });
}
export function fetchDelete(roleIds) {
  var data = {
    roleIds: roleIds
  };
  return request({
    url: '/userservice/api/role/delete',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/userservice/api/role/create',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/userservice/api/role/update',
    method: 'post',
    data: data
  });
}
export function fetchRoleMenu(roleId) {
  var data = {
    roleId: roleId
  };
  return request({
    url: '/userservice/api/role/getRoleMenuList',
    method: 'post',
    data: data
  });
}
export function fetchCreateRoleMenu(roleId, addIdList) {
  var data = {
    roleId: roleId,
    addIdList: addIdList
  };
  return request({
    url: '/userservice/api/role/insertRoleMenu',
    method: 'post',
    data: data
  });
}
export function fetchRoleDeptUser(roleId, deptId) {
  var data = {
    roleId: roleId,
    deptId: deptId
  };
  return request({
    url: '/userservice/api/role/getDeptUserList',
    method: 'post',
    data: data
  });
}
export function fetchToushu(data) {
  return request({
    url: '/userservice/api/role/getDeptUserList',
    method: 'post',
    data: data
  });
}
export function fetchCreateRoleUser(roleId, addIdList) {
  var data = {
    roleId: roleId,
    addIdList: addIdList
  };
  return request({
    url: '/userservice/api/role/insertUserRole',
    method: 'post',
    data: data
  });
}
export function fetchCreateRoleMenuAdmin(data) {
  return request({
    url: '/userservice/api/role/insertRoleMenu',
    method: 'post',
    data: data
  });
}